import type { ParsedFormField } from './parseFormFields';
import { pickChrome } from './siteChromeCopy';

/** ODL-aligned reservation fallbacks when `formFields` is empty. */
export function defaultReservationFields(locale: string): ParsedFormField[] {
  return [
    { name: 'name', type: 'text', required: true, label: pickChrome('fieldName', locale) },
    { name: 'email', type: 'email', required: true, label: pickChrome('fieldEmail', locale) },
    { name: 'phone', type: 'tel', required: true, label: pickChrome('fieldPhone', locale) },
    { name: 'guests', type: 'number', required: true, label: pickChrome('fieldGuests', locale) },
    { name: 'date', type: 'date', required: true, label: pickChrome('fieldDate', locale) },
    { name: 'time', type: 'time', required: true, label: pickChrome('fieldTime', locale) },
    {
      name: 'message',
      type: 'textarea',
      required: false,
      label: pickChrome('fieldMessage', locale),
    },
  ];
}

/** ODL-aligned allergy fallbacks (consent rendered separately from content). */
export function defaultAllergyFields(locale: string): ParsedFormField[] {
  return [
    { name: 'name', type: 'text', required: true, label: pickChrome('fieldName', locale) },
    { name: 'email', type: 'email', required: true, label: pickChrome('fieldEmail', locale) },
    {
      name: 'allergens',
      type: 'textarea',
      required: true,
      label: pickChrome('fieldAllergens', locale),
    },
  ];
}

/** ODL-aligned café pre-order fallbacks when `formFields` is empty. */
export function defaultPreOrderFields(locale: string): ParsedFormField[] {
  return [
    { name: 'name', type: 'text', required: true, label: pickChrome('fieldName', locale) },
    { name: 'email', type: 'email', required: true, label: pickChrome('fieldEmail', locale) },
    { name: 'phone', type: 'tel', required: false, label: pickChrome('fieldPhone', locale) },
    {
      name: 'pickup',
      type: 'text',
      required: true,
      label: locale === 'de' ? 'Abholung' : locale === 'vi' ? 'Nhận hàng' : 'Pickup time',
    },
    {
      name: 'items',
      type: 'textarea',
      required: true,
      label: locale === 'de' ? 'Bestellung' : locale === 'vi' ? 'Đơn hàng' : 'Order items',
    },
  ];
}

/** ODL-aligned catering inquiry fallbacks when `formFields` is empty. */
export function defaultCateringFields(locale: string): ParsedFormField[] {
  return [
    { name: 'name', type: 'text', required: true, label: pickChrome('fieldName', locale) },
    { name: 'email', type: 'email', required: true, label: pickChrome('fieldEmail', locale) },
    { name: 'phone', type: 'tel', required: false, label: pickChrome('fieldPhone', locale) },
    { name: 'date', type: 'date', required: true, label: pickChrome('fieldDate', locale) },
    { name: 'guests', type: 'number', required: true, label: pickChrome('fieldGuests', locale) },
    {
      name: 'message',
      type: 'textarea',
      required: true,
      label: pickChrome('fieldMessage', locale),
    },
  ];
}

/** Short guest message — name, email, optional callback number, note. */
export function defaultContactFields(locale: string): ParsedFormField[] {
  return [
    { name: 'name', type: 'text', required: true, label: pickChrome('fieldName', locale) },
    { name: 'email', type: 'email', required: true, label: pickChrome('fieldEmail', locale) },
    { name: 'phone', type: 'tel', required: false, label: pickChrome('fieldPhone', locale) },
    {
      name: 'message',
      type: 'textarea',
      required: true,
      label: pickChrome('fieldMessage', locale),
    },
  ];
}

/** ODL-aligned private-party inquiry fallbacks when `formFields` is empty. */
export function defaultPrivatePartyFields(locale: string): ParsedFormField[] {
  return [
    { name: 'name', type: 'text', required: true, label: pickChrome('fieldName', locale) },
    { name: 'email', type: 'email', required: true, label: pickChrome('fieldEmail', locale) },
    { name: 'phone', type: 'tel', required: false, label: pickChrome('fieldPhone', locale) },
    { name: 'date', type: 'date', required: false, label: pickChrome('fieldDate', locale) },
    { name: 'guests', type: 'number', required: false, label: pickChrome('fieldGuests', locale) },
    {
      name: 'message',
      type: 'textarea',
      required: true,
      label: pickChrome('fieldMessage', locale),
    },
  ];
}
